<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">寻人区</div>
      <div class="nav-right">
        <span class="nav-lable none">历史</span>
        <img src="../../assets/img/添加.png" class="nav-img" @click="goto_Release()"/>
      </div>
    </div>

    <div class="block">
      <div class="main" v-for="(item, index) in tie" :key="index">
        <div v-if="item.refurbish_count > 0" class="top-position" :style="{ 'background-image': 'url(' + back_img + ')' }"></div>

        <div class="tit-block ub ub-pc ub-ac2">
          <div class="ub ub-f1" @click="dtl(item.id)">
           <span class="val">{{ item.title }}</span>
          </div>
        </div>

        <div class="line"></div>

        <div class="dtl-block ub ub-pc ub-ac2">
          <div @click="toptie(item.id)" class="top-paste"><span>顶帖</span></div >
          <div class="ub ub-ver">
            <div class="ub ub-ac ub-pc" @click="goto_chat(item.id)">
              <img :src="item.photo" class="photo" />
              <span class="nick2">{{ item.nick }}</span>
            </div>

            <div> <span class="datetime">{{ item.create_time }}</span></div>
          </div>

        </div>
      </div>
      <div class="ub ub-pc ub-ac">
        <div class="btn ub ub-ac ub-pc" @click="load_more()"><span>加载更多</span></div>
      </div>
      <dlg ref="myForm_2"></dlg>
    </div>

    <dlg ref="myForm" @formBehavior="formact_claim"></dlg>
    <dlg ref="myForm_drop_tie" @formBehavior="myform_drop_tie"></dlg>
    <dlg ref="myForm_top" @formBehavior="formact_top_tie"></dlg>
    <dlg ref="myForm_chat" @formBehavior="formact_chat"></dlg>
    <dlg ref="myForm_lookwechat" @formBehavior="formact_lookwechat"></dlg>
    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../../components/Form.vue";
import Alert from "../../components/Alert.vue";
export default {
  components: {
    dlg: Form,
    alert: Alert,
  },
  data() {
    return {
      tie: [
        {
          id: "wx_VTVSHL2HJMUHH69F",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          nick: "鸣人",
          create_time: "2021-01-01",
          title: "找一个成都的小哥哥",
        },
      ],
      index: 0,
      size: 20,
      coin_left: 0,

      wx_real: "",
      back_img: require("../../assets/img/置顶.png"),
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo", "act_sub_coin"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var self = this;
      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user_info = u;
          self.coin_left = u.coin_left;
        },
      });

      this.index = 0;
      this.tie = [];
      this.load_more();
    },

    //点击头像，弹提示
    goto_chat(id) {
      var self = this;
      this.$loading('加载...');
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_seek_people_Data_One/?id=" + id,
        success: function (data) {
          self.$loading.close();
          //console.log(JSON.stringify(data));
          var photo = self.$store.state.url + "/photo/" + data.photo;
          var nick = data.nick;
          var sex_img = require("../../assets/img/男.png");
          var totalcoin = data.totalcoin;
          var totalscore = data.totalscore;
          var uid_to = data.uid;
          var sex = data.sex;
          if(sex == "女生"){
             var sex_img = require("../../assets/img/女.png");
          }
          var h = 
          " <div class='xrq-dtl'>\
                <div class='ub ub-ac1'>\
                    <div class='ub ub-ac ub-pc ub-ver'>\
                      <img src='" + photo + "' class='photo'/>\
                      <div class='nick ub ub-pc'>\
                          <span>" + nick + "</span>\
                          <img src='" + sex_img + "'/>\
                      </div>\
                    </div>\
                    <div class='num ub ub-ac2 ub-pc'>\
                        <div class='ub ub-ver ub-pc'>\
                          <span class='sp1'>" + totalcoin +"</span>\
                          <span class='sp1'>豪气值</span>\
                        </div>\
                        <div class='ub ub-ver ub-pc'>\
                          <span class='sp2'>" + totalscore + "</span>\
                          <span class='sp2'>魅力值</span>\
                      </div>\
                    </div>\
                </div>\
                <div class='line'></div>\
                <div class='tips'>和Ta聊天的人太多啦，为了防止用户受到骚扰，想要和她聊天需要支付200金币为对方赠送一个小礼物，确定聊天，请点击下方【撩Ta】按钮</div>\
            </div>";

          self.$refs.myForm_chat.show(h, {
            type: "confirm",
            confirmText: "撩Ta",
            titleText: "温馨提示",
            data: uid_to,
          });
        },
      });
    },

    formact_chat(type, uid_to) {
      if (type != "clickConfirm") {
        return false;
      }
      //判断金币够不够支付
      if (this.coin_left < 100) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      //扣除金币
      var uid = this.$store.state.uid;
      var data = {
        uid: uid,
        uid_to: uid_to,
        coin: 200,
      };
      this.sub_coin_chat(data);
    },

    //扣除金币
    sub_coin_chat(data) {
      var send_data = {
        uid_from: data.uid,
        uid_to: data.uid_to,
        amount: data.coin,
        type_dtl: "寻人区聊天",
        comment: "",
      };
      //console.log(JSON.stringify(send_data));
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          //console.log(JSON.stringify(res));
          if (res.state == "1") {
            //console.log(JSON.stringify(data));
            self.$router.push({ name: "chart", params: { uid: data.uid_to } });
          }
        },
      });
    },

    load_more() {
      this.$loading("加载...");

      //加载数据(按条数加载)
      var self = this;
      self.get({
        url:
          "/App/Get_seek_people_Data/?index=" +
          this.index +
          "&size=" +
          this.size,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.$loading.close();

          if (data.length <= 0 && self.index > 0) {
            self.$toast.bottom("没有更多了~");
          }
          self.index++;

          for (var i = 0; i < data.length; i++) {
            data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
          self.tie = self.tie.concat(data);
        },
      });
    },

    goto_Release() {
      //检测是否关注公众号
      var skipWxCheck = this.$store.state.skipWxCheck;
      if (!skipWxCheck) {
        var wxInfo = this.$store.state.wxInfo;
        if(wxInfo == ""){
          this.show_sys_GuanzhuWx();
          return false;
        }
      }
      
      this.$router.push({ name: "release" });
    },

    //关注公众号提示
    show_sys_GuanzhuWx() {
      var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
      var gzh_name = '小火柴';
      var code_link='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NzM4MTAzOQ==#wechat_redirect';
      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if(sysdic){
        qrcode_url = sysdic.wx_gzh_qrcode;
        gzh_name = sysdic.wx_gzh_name;
      }

      var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"发帖"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)" href='+code_link+'>'+ gzh_name +'<a/>】，开启发帖功能~<div>'
        + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '"  style="margin: 1rem 0"/></div>'
        + '<div style="line-height:1.6em; text-align:center;">长按开启发帖功能<div>'
      this.$refs.myForm_2.show(h, {
        type: 'alert',
        confirmText: '长按上方二维码',
        titleText: '温馨提示',
        data: ''
      });
    },


    dtl(id) {
      //通过 id 加载数据
      var self = this;
      this.$loading('加载...');
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_seek_people_Data_One/?id=" + id,
        success: function (data) {
          self.$loading.close();
          //console.log(JSON.stringify(data));
          var uid = self.$store.state.uid;
          var id = data.id;
          var content = data.content;
          var create_time = data.create_time;
          var title = data.title;
          var photo = self.$store.state.url + "/photo/" + data.photo;
          var nick = data.nick;
          var sex_img = require("../../assets/img/男.png");
          var wx = data.wx.substr(0, 4) + "***";
          self.wx_real = data.wx;
          var totalcoin = data.totalcoin;
          var totalscore = data.totalscore;
          var uid_to = data.uid;
          if(data.sex == "女生"){
            sex_img = require("../../assets/img/女.png");
          }
          var h =
            " <div class='xrq-dtl'>\
                <div class='ub ub-ac1' >\
                    <div class='ub ub-ac ub-pc ub-ver'>\
                      <img src='" + photo +"' class='photo'/>\
                      <div class='nick ub ub-pc'>\
                          <span>" + nick +"</span>\
                          <img src='" +sex_img +"'/>\
                      </div>\
                    </div>\
                    <div class='num ub ub-ac2 ub-pc'>\
                        <div class='ub ub-pc ub-ver'>\
                          <span class='sp1'>" +totalcoin +"</span>\
                          <span class='sp1'>豪气值</span>\
                        </div>\
                        <div class='ub ub-pc ub-ver'>\
                          <span class='sp2'>" +totalscore +"</span>\
                          <span class='sp2'>魅力值</span>\
                        </div>\
                    </div>\
                </div>\
                <div class='line'></div>\
                <div class='content'>" +content +"</div>\
                <div class='wx ub ub-ac2'>\
                      <div>ta的微信号:<label>" +wx +"</label></div>\
                </div>\
                <div class='tips'>为了防止Ta受到骚扰，查看微信需支付3000金币。</div>\
            </div>";

          //判断是否为自己，进行删除

          if (uid_to == uid) {
            self.$refs.myForm_drop_tie.show(h, {
              type: "confirm",
              confirmText: "删除此贴",
              titleText: title,
              data: id,
            });
          } else {
            self.$refs.myForm.show(h, {
              type: "confirm",
              confirmText: "查看微信",
              titleText: title,
              data: uid_to,
            });
          }
        },
      });
    },

    myform_drop_tie(type, id) {
      if (type == "clickConfirm") {
        var self = this;
        self.get({
          url: "/App/Seek_People_drop_tie/?id=" + id,
          success: function (data) {
            //console.log(data);
            if (data == "1") {
              self.$toast.top("删除成功");
              self.init_page();
            } else {
              self.$toast.center("删除失败,请退出重试");
            }
          },
        });
      }
    },
    formact_claim(type, uid_to) {
      if (type != "clickConfirm") {
        return false;
      }
      if (this.coin_left < 3000) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      //扣除金币
      var uid = this.$store.state.uid;
      var data = {
        uid: uid,
        uid_to: uid_to,
        coin: 3000,
      };
      this.sub_coin_lookwechat(data);

      this.watchwechat();
    },

    //扣除金币
    sub_coin_lookwechat(data) {
      var send_data = {
        uid_from: data.uid,
        uid_to: data.uid_to,
        amount: data.coin,
        type_dtl: "寻人区查看微信",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          //console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.watchwechat();
          }
        },
      });
    },

    //查看完整微信
    watchwechat() {
      var h =
        "<div style='font-size:.85em'>查看成功，微信号：</div>\
      <div style='color:red;display: flex;align-items: center;font-weight: bold;padding:.5em 0;font-size:1.5em;'>" +
        this.wx_real +
        "</div>\
      <div style='font-size:.85em'>请将此页面截屏保存，以免丢失</div>";
      var self = this;
      self.$refs.myForm_lookwechat.show(h, {
        type: "confirm",
        confirmText: "确定",
        titleText: "微信号",
        data: "",
      });
    },

    formact_lookwechat(type, data) {
      if (type == "clickConfirm") {
      }
    },

    //点击顶，弹出提示
    toptie(id) {
      var h =
        "顶贴可以将此贴置顶，可以获取更大的曝光度，置顶一次需要支付100金币";
      this.$refs.myForm_top.show(h, {
        type: "confirm",
        confirmText: "确定",
        titleText: "温馨提示",
        data: id,
      });
    },

    formact_top_tie(type, id) {
      if (type != "clickConfirm") {
        return false;
      }

      //判断有没有金币
      if (this.coin_left < 100) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      //扣除金币
      var uid = this.$store.state.uid;
      var data = {
        uid: uid,
        coin: 100,
        id: id,
      };
      this.sub_coin_relieve2(data);
    },

    //金币不足跳转充值
    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },

    //顶帖
    top_tie(id) {
      var self = this;
      self.get({
        url: "/App/ReFresh/?id=" + id,
        success: function (data_rst) {
          //console.log(data_rst);
          if (data_rst == "1") {
            self.$toast.top("置顶成功");
            self.init_page();
          } else {
            self.$toast.center("置顶失败,请退出重试");
          }
        },
      });
    },

    //扣除金币
    sub_coin_relieve2(data) {
      var send_data = {
        uid_from: data.uid,
        uid_to: "",
        amount: data.coin,
        type_dtl: "顶帖",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          //console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.top_tie(data.id);
          }
        },
      });
    },
  },
};
</script>
<style lang="scss">
.xrq-dtl {
  .photo {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
  .nick {
    margin-top: .3rem;
    span {
      font-size:.9rem;
      color: #666;
    }
    img {
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
    }
  }
  .num {
    width: 9rem;
    margin-top: .8rem;
    font-size:.9rem;
    .sp1 {
      color:#fdaf1d;
    }
    .sp2 {
      color:#e92162;
    }
  }
  .content {
    margin:.3rem 0;
    font-size:1rem;
    word-wrap:break-word
  }
  .line {
    border-top: 0.1px dashed #f1f1f1;
    margin: .3rem 0;
  }
  .wx {
    font-size:.75rem;
    margin-top: .8rem;
    color: #beb8b8;
    label {
      color:red;
    }
  }
  .tips {
    font-size:.9rem;
    color:#9f9f9f;
  }
}
</style>
<style lang="scss" scoped>
.block {
  padding: 0.8rem 0.8rem 0 0.8rem;
  .main {
    background-color: #fff;
    padding: 0.5rem;
    border-radius: 0.3rem;
    margin-bottom: 0.8rem;
    position: relative;
    .top-position {
      position: absolute;
      height: 1.5rem;
      width: 1.5rem;
      background-size: 100% 100%;
      right: 4px;
      top: 4px;
    }
    .tit-block {
      padding: 0.4rem 0;
      margin: .5rem 0;
      .val {
        font-size: 1rem;
        color: blue;
      }
    }
    .line {
      border-top: 1px dashed #f1f1f1;
      margin: 0.3rem;
    }
    .dtl-block {
      .top-paste {
        padding: 0.2rem 1rem;
        border: 1px solid #8a2ef3;
        border-radius: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #8a2ef3;
        }
      }
      .photo {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        margin-right: 0.3rem;
      }
      .nick2 {
        font-size: 0.8rem;
      }
      .datetime {
        font-size: 0.8rem;
        color: #beb8b8;
      }
    }
  }
  .btn {
    margin: 1rem 0;
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .block {
    .main {
      background-color: #2c2b30;
    }
    .tit-block {
      .val {
        color: #fafafa;
      }
    }
    .line {
      border-top: 1px dashed #404040;
    }
    .dtl-block {
      .top-paste {
        border: 1px solid #8a2ef3;
        span {
          color: #8a2ef3;
        }
      }
      .nick2 {
        color: #FDFDFD;
      }
    }
  }
}
</style>
